import id from "./[id].json";

const images = {"modules.pages.images.id": id};

export {images};
